import script from "./BaseSidePanelRecord.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSidePanelRecord.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSidePanelRecord.vue?vue&type=style&index=0&id=6e5222fe&lang=sass"

const __exports__ = script;

export default __exports__